/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaseWorkPeriod } from './CaseWorkPeriod';
import {
    CaseWorkPeriodFromJSON,
    CaseWorkPeriodFromJSONTyped,
    CaseWorkPeriodToJSON,
    CaseWorkPeriodToJSONTyped,
} from './CaseWorkPeriod';
import type { CaseSource } from './CaseSource';
import {
    CaseSourceFromJSON,
    CaseSourceFromJSONTyped,
    CaseSourceToJSON,
    CaseSourceToJSONTyped,
} from './CaseSource';
import type { CaseEntity } from './CaseEntity';
import {
    CaseEntityFromJSON,
    CaseEntityFromJSONTyped,
    CaseEntityToJSON,
    CaseEntityToJSONTyped,
} from './CaseEntity';
import type { CaseType } from './CaseType';
import {
    CaseTypeFromJSON,
    CaseTypeFromJSONTyped,
    CaseTypeToJSON,
    CaseTypeToJSONTyped,
} from './CaseType';
import type { CloseReason } from './CloseReason';
import {
    CloseReasonFromJSON,
    CloseReasonFromJSONTyped,
    CloseReasonToJSON,
    CloseReasonToJSONTyped,
} from './CloseReason';
import type { CaseFeedback } from './CaseFeedback';
import {
    CaseFeedbackFromJSON,
    CaseFeedbackFromJSONTyped,
    CaseFeedbackToJSON,
    CaseFeedbackToJSONTyped,
} from './CaseFeedback';
import type { Event } from './Event';
import {
    EventFromJSON,
    EventFromJSONTyped,
    EventToJSON,
    EventToJSONTyped,
} from './Event';
import type { SystemBoundaryEntity } from './SystemBoundaryEntity';
import {
    SystemBoundaryEntityFromJSON,
    SystemBoundaryEntityFromJSONTyped,
    SystemBoundaryEntityToJSON,
    SystemBoundaryEntityToJSONTyped,
} from './SystemBoundaryEntity';

/**
 * 
 * @export
 * @interface Case
 */
export interface Case {
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    id?: string;
    /**
     * 
     * @type {CaseType}
     * @memberof Case
     */
    caseType?: CaseType;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    severity?: CaseSeverityEnum;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    status?: CaseStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof Case
     */
    created?: Date;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    owner?: string;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    modified?: string;
    /**
     * 
     * @type {Date}
     * @memberof Case
     */
    updated?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof Case
     */
    escalated?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Case
     */
    escalationCount?: number;
    /**
     * 
     * @type {Array<Event>}
     * @memberof Case
     */
    events?: Array<Event>;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    summary?: string;
    /**
     * 
     * @type {Array<CaseEntity>}
     * @memberof Case
     */
    entities?: Array<CaseEntity>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Case
     */
    customFields?: { [key: string]: any; };
    /**
     * 
     * @type {CloseReason}
     * @memberof Case
     */
    closeReason?: CloseReason;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    closeRationale?: string;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    goldenRecordId?: string;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    createdByUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    updatedByUserId?: string;
    /**
     * 
     * @type {Date}
     * @memberof Case
     */
    originalCreatedTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Case
     */
    assignedTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Case
     */
    closedTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Case
     */
    escalatedTime?: Date;
    /**
     * 
     * @type {Array<CaseSource>}
     * @memberof Case
     */
    sources?: Array<CaseSource>;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    correlationGroup?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Case
     */
    correlationMetadata?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Case
     */
    metadata?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    sourceId?: string;
    /**
     * 
     * @type {number}
     * @memberof Case
     */
    notifySLATimer?: number;
    /**
     * 
     * @type {number}
     * @memberof Case
     */
    detectionSLATimer?: number;
    /**
     * 
     * @type {Set<SystemBoundaryEntity>}
     * @memberof Case
     */
    affectedBoundaries?: Set<SystemBoundaryEntity>;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    boundaryImpactSummary?: string;
    /**
     * 
     * @type {number}
     * @memberof Case
     */
    assignmentSLATimer?: number;
    /**
     * 
     * @type {number}
     * @memberof Case
     */
    remediationSLATimer?: number;
    /**
     * 
     * @type {number}
     * @memberof Case
     */
    durationSLATimer?: number;
    /**
     * 
     * @type {Array<CaseFeedback>}
     * @memberof Case
     */
    feedback?: Array<CaseFeedback>;
    /**
     * 
     * @type {Array<CaseWorkPeriod>}
     * @memberof Case
     */
    workPeriods?: Array<CaseWorkPeriod>;
}


/**
 * @export
 */
export const CaseSeverityEnum = {
    Critical: 'CRITICAL',
    High: 'HIGH',
    Medium: 'MEDIUM',
    Low: 'LOW',
    Info: 'INFO'
} as const;
export type CaseSeverityEnum = typeof CaseSeverityEnum[keyof typeof CaseSeverityEnum];

/**
 * @export
 */
export const CaseStatusEnum = {
    Open: 'OPEN',
    InProgress: 'IN_PROGRESS',
    Escalated: 'ESCALATED',
    Resolved: 'RESOLVED'
} as const;
export type CaseStatusEnum = typeof CaseStatusEnum[keyof typeof CaseStatusEnum];


/**
 * Check if a given object implements the Case interface.
 */
export function instanceOfCase(value: object): value is Case {
    return true;
}

export function CaseFromJSON(json: any): Case {
    return CaseFromJSONTyped(json, false);
}

export function CaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): Case {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'caseType': json['caseType'] == null ? undefined : CaseTypeFromJSON(json['caseType']),
        'severity': json['severity'] == null ? undefined : json['severity'],
        'name': json['name'] == null ? undefined : json['name'],
        'status': json['status'] == null ? undefined : json['status'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'owner': json['owner'] == null ? undefined : json['owner'],
        'modified': json['modified'] == null ? undefined : json['modified'],
        'updated': json['updated'] == null ? undefined : (new Date(json['updated'])),
        'escalated': json['escalated'] == null ? undefined : json['escalated'],
        'escalationCount': json['escalationCount'] == null ? undefined : json['escalationCount'],
        'events': json['events'] == null ? undefined : ((json['events'] as Array<any>).map(EventFromJSON)),
        'summary': json['summary'] == null ? undefined : json['summary'],
        'entities': json['entities'] == null ? undefined : ((json['entities'] as Array<any>).map(CaseEntityFromJSON)),
        'customFields': json['customFields'] == null ? undefined : json['customFields'],
        'closeReason': json['closeReason'] == null ? undefined : CloseReasonFromJSON(json['closeReason']),
        'closeRationale': json['closeRationale'] == null ? undefined : json['closeRationale'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'goldenRecordId': json['goldenRecordId'] == null ? undefined : json['goldenRecordId'],
        'createdByUserId': json['createdByUserId'] == null ? undefined : json['createdByUserId'],
        'updatedByUserId': json['updatedByUserId'] == null ? undefined : json['updatedByUserId'],
        'originalCreatedTime': json['originalCreatedTime'] == null ? undefined : (new Date(json['originalCreatedTime'])),
        'assignedTime': json['assignedTime'] == null ? undefined : (new Date(json['assignedTime'])),
        'closedTime': json['closedTime'] == null ? undefined : (new Date(json['closedTime'])),
        'escalatedTime': json['escalatedTime'] == null ? undefined : (new Date(json['escalatedTime'])),
        'sources': json['sources'] == null ? undefined : ((json['sources'] as Array<any>).map(CaseSourceFromJSON)),
        'correlationGroup': json['correlationGroup'] == null ? undefined : json['correlationGroup'],
        'correlationMetadata': json['correlationMetadata'] == null ? undefined : json['correlationMetadata'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'sourceId': json['sourceId'] == null ? undefined : json['sourceId'],
        'notifySLATimer': json['notifySLATimer'] == null ? undefined : json['notifySLATimer'],
        'detectionSLATimer': json['detectionSLATimer'] == null ? undefined : json['detectionSLATimer'],
        'affectedBoundaries': json['affectedBoundaries'] == null ? undefined : (new Set((json['affectedBoundaries'] as Array<any>).map(SystemBoundaryEntityFromJSON))),
        'boundaryImpactSummary': json['boundaryImpactSummary'] == null ? undefined : json['boundaryImpactSummary'],
        'assignmentSLATimer': json['assignmentSLATimer'] == null ? undefined : json['assignmentSLATimer'],
        'remediationSLATimer': json['remediationSLATimer'] == null ? undefined : json['remediationSLATimer'],
        'durationSLATimer': json['durationSLATimer'] == null ? undefined : json['durationSLATimer'],
        'feedback': json['feedback'] == null ? undefined : ((json['feedback'] as Array<any>).map(CaseFeedbackFromJSON)),
        'workPeriods': json['workPeriods'] == null ? undefined : ((json['workPeriods'] as Array<any>).map(CaseWorkPeriodFromJSON)),
    };
}

export function CaseToJSON(json: any): Case {
    return CaseToJSONTyped(json, false);
}

export function CaseToJSONTyped(value?: Case | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'caseType': CaseTypeToJSON(value['caseType']),
        'severity': value['severity'],
        'name': value['name'],
        'status': value['status'],
        'created': value['created'] == null ? undefined : ((value['created']).toISOString()),
        'owner': value['owner'],
        'modified': value['modified'],
        'updated': value['updated'] == null ? undefined : ((value['updated']).toISOString()),
        'escalated': value['escalated'],
        'escalationCount': value['escalationCount'],
        'events': value['events'] == null ? undefined : ((value['events'] as Array<any>).map(EventToJSON)),
        'summary': value['summary'],
        'entities': value['entities'] == null ? undefined : ((value['entities'] as Array<any>).map(CaseEntityToJSON)),
        'customFields': value['customFields'],
        'closeReason': CloseReasonToJSON(value['closeReason']),
        'closeRationale': value['closeRationale'],
        'tenantId': value['tenantId'],
        'goldenRecordId': value['goldenRecordId'],
        'createdByUserId': value['createdByUserId'],
        'updatedByUserId': value['updatedByUserId'],
        'originalCreatedTime': value['originalCreatedTime'] == null ? undefined : ((value['originalCreatedTime']).toISOString()),
        'assignedTime': value['assignedTime'] == null ? undefined : ((value['assignedTime']).toISOString()),
        'closedTime': value['closedTime'] == null ? undefined : ((value['closedTime']).toISOString()),
        'escalatedTime': value['escalatedTime'] == null ? undefined : ((value['escalatedTime']).toISOString()),
        'sources': value['sources'] == null ? undefined : ((value['sources'] as Array<any>).map(CaseSourceToJSON)),
        'correlationGroup': value['correlationGroup'],
        'correlationMetadata': value['correlationMetadata'],
        'metadata': value['metadata'],
        'sourceId': value['sourceId'],
        'notifySLATimer': value['notifySLATimer'],
        'detectionSLATimer': value['detectionSLATimer'],
        'affectedBoundaries': value['affectedBoundaries'] == null ? undefined : (Array.from(value['affectedBoundaries'] as Set<any>).map(SystemBoundaryEntityToJSON)),
        'boundaryImpactSummary': value['boundaryImpactSummary'],
        'assignmentSLATimer': value['assignmentSLATimer'],
        'remediationSLATimer': value['remediationSLATimer'],
        'durationSLATimer': value['durationSLATimer'],
        'feedback': value['feedback'] == null ? undefined : ((value['feedback'] as Array<any>).map(CaseFeedbackToJSON)),
        'workPeriods': value['workPeriods'] == null ? undefined : ((value['workPeriods'] as Array<any>).map(CaseWorkPeriodToJSON)),
    };
}

